// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ffe92137","977":"c024cc74"}[chunkId] + ".chunk.js";
};